export default __webpack_public_path__ + "static/store-google.ja-aab8cd90ac57daa8ff94275592a1cd8e.png";